import Random from "another-random-package";
import React from "react";
import "./masonry.scss";

import PortfolioImageWrapper from "../imageWrapper/illustrationPortfolioWrapper";



const Masonry = props => {
    const {imageClick,handleCounter,viewportWidth,rows,sizes,carousel,photos} = props;
    function handleClick (handler) {
        return (event)=> {
            document.body.classList.toggle("modal-open");
            let i = Number(event.target.getAttribute("data-index"))
            handleCounter(0,i)();
            handler(carousel[i])
        }
    }
    let sizer = (v) => v / viewportWidth * 100 * .78;
    let preFixer = (v) => `${v}vw`;

    let imgIndex = 0;

    return (
        <section className={"masonry"}>
            {props.children}
            { viewportWidth && rows.map((row,i)=>{
                    return (
                        <div
                            className="masonry-row"
                            key={Random.randomStringAlphaNumeric(12)}
                        >
                            {row.map(({category,index},j)=>{
                                let width = sizes[i] ? `${sizes[i][j].width}` : "";
                                let height = sizes[i] ?`${sizes[i][j].height}` : "";

                                let maxWidth = `${(1280 / 100) * sizer(+width)}px`;
                                let maxHeight = `${(1280 / 100) * sizer(+height)}px`;

                                width = preFixer(sizer(+width));
                                height= preFixer(sizer(+height));
                                let {images:{sources, fallback},backgroundColor} = photos[category][index];
                                imgIndex++
                                return (row.length > 1 ?
                                    <PortfolioImageWrapper
                                    sources={sources}
                                    data-index={imgIndex-1}
                                    fallback={fallback}
                                    category={category}
                                    className={category}
                                    key={Random.randomStringAlphaNumeric(12)}
                                    alt="Illustration photo by Lauren Staser."
                                    onClick={handleClick(imageClick)}
                                    style ={{
                                        height,
                                        width,
                                        maxWidth,
                                        maxHeight,
                                        backgroundColor
                                    }}
                                    />:
                                    <PortfolioImageWrapper
                                        sources={sources}
                                        fallback={fallback}
                                        data-index={imgIndex-1}
                                        category={category}
                                        className={category}
                                        alt="Illustration photo by Lauren Staser."
                                        key={Random.randomStringAlphaNumeric(12)}
                                        onClick={handleClick(imageClick)}
                                        style={{
                                            width:"100%",
                                            height:"auto"
                                        }}
                                    />

                                )
                            })}
                        </div>
                    )
                })}
        </section>
    );
};

export default Masonry